// extracted by mini-css-extract-plugin
export default {"modal":"branchModal_modal__Q-CB4","popup":"branchModal_popup__a2bSY"};